(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigDialogController', CardPrefixConfigDialogController);

    CardPrefixConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CardPrefixConfig'];

    function CardPrefixConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CardPrefixConfig) {
        var vm = this;

        vm.cardPrefixConfig = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.cardPrefixes = [];
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.checkDuplicatePrefix = checkDuplicatePrefix;

        if (!vm.cardPrefixConfig.id) {
            vm.cardPrefixConfig.isActive = true;
        }

        loadAll();

        function loadAll () {
            vm.cardPrefixes = [];
            vm.allCardPrefixStatus = true;
            CardPrefixConfig.query(function (result) {
                angular.forEach(result, function (res) {
                    var cardPrefix = {
                        id: res.id,
                        prefix: res.prefix,
                        cardType: res.cardType,
                        isActive: res.isActive,
                        lastModifiedDate: res.lastModifiedDate,
                        lastModifiedBy: res.lastModifiedBy
                    };
                    vm.cardPrefixes.push(cardPrefix);
                    if (!res.isActive) {
                        vm.allCardPrefixStatus = false;
                    }
                    vm.filteredCardPrefixes = angular.copy(result);
                });
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cardPrefixConfig.id !== null) {
                CardPrefixConfig.update(vm.cardPrefixConfig, onSaveSuccess, onSaveError);
            } else {
                CardPrefixConfig.save(vm.cardPrefixConfig, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:cardPrefixConfigUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function checkDuplicatePrefix() {
            if (!vm.cardPrefixConfig.prefix || !vm.cardPrefixes) return;

            var existing = vm.cardPrefixes.find(function (cardPrefix) {
                return cardPrefix.prefix === vm.cardPrefixConfig.prefix && cardPrefix.id !== vm.cardPrefixConfig.id;
            });

            vm.isDuplicatePrefix = !!existing;
        }
    }
})();
